export function sendTrackingEvent(action: string) {
  if (window.gtag) {
    window.gtag("event", action);
  }
}
